// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header3_header__SPZPi {
  padding: 5rem;
  box-sizing: border-box;
  background-color: var(--color-white);
}
@media only screen and (max-width: 62.5em) {
  .Header3_header__SPZPi {
    padding: 5rem 5rem;
  }
}
.Header3_header__nav__Tnq2J {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
@media only screen and (max-width: 62.5em) {
  .Header3_header__nav__Tnq2J {
    justify-content: space-between;
  }
}
.Header3_header__nav__btn__qUlaI {
  display: flex;
  gap: 2.3rem;
}
@media only screen and (max-width: 62.5em) {
  .Header3_header__nav__btn__qUlaI {
    display: none;
  }
}
.Header3_header__nav_icon__zxaHn {
  display: none;
  cursor: pointer;
}
@media only screen and (max-width: 62.5em) {
  .Header3_header__nav_icon__zxaHn {
    display: block;
    font-size: 5rem;
  }
  .Header3_header__nav_icon__zxaHn:hover {
    color: var(--color-primary);
  }
}

.Header3_logo__ruMUR {
  width: 18rem;
  height: 100%;
}

.Header3_nav__item__2X5Bu {
  display: flex;
  list-style: none;
}
.Header3_nav__item__list__S8JQc {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header3_nav__item__list__S8JQc:hover, .Header3_nav__item__list__S8JQc:active {
  font-weight: 700;
  color: var(--color-primary);
}
.Header3_nav__item__list__S8JQc:not(:last-child) {
  margin-right: 2.5rem;
}
.Header3_nav__item__link__I3i7g:link, .Header3_nav__item__link__I3i7g:visited {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header3_nav__item__link__I3i7g:link:hover, .Header3_nav__item__link__I3i7g:link:active, .Header3_nav__item__link__I3i7g:visited:hover, .Header3_nav__item__link__I3i7g:visited:active {
  font-weight: 700;
  color: var(--color-primary);
}
@media only screen and (max-width: 62.5em) {
  .Header3_nav__item__2X5Bu {
    display: none;
  }
}

.Header3_menu__lP4md {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-light);
  position: fixed;
  padding: 5rem 10rem;
  overflow-y: scroll;
  z-index: 100;
}
@media only screen and (max-width: 37.5em) {
  .Header3_menu__lP4md {
    padding: 5rem 5rem;
  }
}
.Header3_menu__logo__V4\\+Tb {
  width: 18rem;
}
.Header3_menu__top__GMjoK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.Header3_menu__icon__qenZl {
  font-size: 5rem;
  color: var(--color-primary);
  cursor: pointer;
}
.Header3_menu__nav__hQB6P {
  height: 50vh;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-subtitle);
  text-align: center;
  justify-content: space-evenly;
  margin-bottom: 2rem;
}
.Header3_menu__nav__item__hHuc8 {
  list-style: none;
}
.Header3_menu__nav__link__fHd37 {
  cursor: pointer;
  text-decoration: none;
  color: var(--color-dark);
}
.Header3_menu__nav__link__fHd37:hover, .Header3_menu__nav__link__fHd37:focus {
  font-weight: 700;
  color: var(--color-primary);
}
.Header3_menu__nav__btn__Ex4bn {
  display: flex;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Header3.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,oCAAA;AADJ;AAGI;EALJ;IAMQ,kBAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;AAAR;AAEQ;EALJ;IAMQ,8BAAA;EACV;AACF;AACQ;EACI,aAAA;EACA,WAAA;AACZ;AACY;EAJJ;IAKQ,aAAA;EAEd;AACF;AACQ;EACI,aAAA;EACA,eAAA;AACZ;AACY;EAJJ;IAKQ,cAAA;IACA,eAAA;EAEd;EAAc;IACI,2BAAA;EAElB;AACF;;AAIA;EACI,YAAA;EACA,YAAA;AADJ;;AAKI;EACI,aAAA;EACA,gBAAA;AAFR;AAIQ;EACI,qBAAA;EACA,wBAAA;EACA,eAAA;AAFZ;AAIY;EAEI,gBAAA;EACA,2BAAA;AAHhB;AAMY;EACI,oBAAA;AAJhB;AAQQ;EAEI,qBAAA;EACA,wBAAA;EACA,eAAA;AAPZ;AASY;EAEI,gBAAA;EACA,2BAAA;AARhB;AAYQ;EAjCJ;IAkCQ,aAAA;EATV;AACF;;AAaA;EACI,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAVJ;AAYI;EATJ;IAUQ,kBAAA;EATN;AACF;AAWI;EACI,YAAA;AATR;AAYI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVR;AAaI;EACI,eAAA;EACA,2BAAA;EACA,eAAA;AAXR;AAcI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAZR;AAcQ;EACI,gBAAA;AAZZ;AAeQ;EACI,eAAA;EACA,qBAAA;EACA,wBAAA;AAbZ;AAeY;EAEI,gBAAA;EACA,2BAAA;AAdhB;AAkBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBZ","sourcesContent":["@import '../variables/breakpoints';\n\n.header {\n    padding: 5rem;\n    box-sizing: border-box;\n    background-color: var(--color-white);\n\n    @media only screen and (max-width: $bp-large) {\n        padding: 5rem 5rem;\n    }\n\n    &__nav {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n\n        @media only screen and (max-width: $bp-large) {\n            justify-content: space-between;\n        }\n\n        &__btn {\n            display: flex;\n            gap: 2.3rem;\n\n            @media only screen and (max-width: $bp-large) {\n                display: none;\n            }\n        }\n\n        &_icon {\n            display: none;\n            cursor: pointer;\n\n            @media only screen and (max-width: $bp-large) {\n                display: block;\n                font-size: 5rem;\n\n                &:hover {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n}\n\n.logo {\n    width: 18rem;\n    height: 100%;\n}\n\n.nav {\n    &__item {\n        display: flex;\n        list-style: none;\n\n        &__list {\n            text-decoration: none;\n            color: var(--color-dark);\n            cursor: pointer;\n\n            &:hover,\n            &:active {\n                font-weight: 700;\n                color: var(--color-primary);\n            }\n\n            &:not(:last-child) {\n                margin-right: 2.5rem;\n            }\n        }\n\n        &__link:link,\n        &__link:visited {\n            text-decoration: none;\n            color: var(--color-dark);\n            cursor: pointer;\n\n            &:hover,\n            &:active {\n                font-weight: 700;\n                color: var(--color-primary);\n            }\n        }\n\n        @media only screen and (max-width: $bp-large) {\n            display: none;\n        }\n    }\n}\n\n.menu {\n    width: 100vw;\n    height: 100vh;\n    background-color: var(--color-light);\n    position: fixed;\n    padding: 5rem 10rem;\n    overflow-y: scroll;\n    z-index: 100;\n\n    @media only screen and (max-width: $bp-small) {\n        padding: 5rem 5rem;\n    }\n\n    &__logo {\n        width: 18rem;\n    }\n\n    &__top {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 2rem;\n    }\n\n    &__icon {\n        font-size: 5rem;\n        color: var(--color-primary);\n        cursor: pointer;\n    }\n\n    &__nav {\n        height: 50vh;\n        display: flex;\n        flex-direction: column;\n        font-size: var(--default-font-subtitle);\n        text-align: center;\n        justify-content: space-evenly;\n        margin-bottom: 2rem;\n\n        &__item {\n            list-style: none;\n        }\n\n        &__link {\n            cursor: pointer;\n            text-decoration: none;\n            color: var(--color-dark);\n\n            &:hover,\n            &:focus {\n                font-weight: 700;\n                color: var(--color-primary);\n            }\n        }\n\n        &__btn {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header3_header__SPZPi`,
	"header__nav": `Header3_header__nav__Tnq2J`,
	"header__nav__btn": `Header3_header__nav__btn__qUlaI`,
	"header__nav_icon": `Header3_header__nav_icon__zxaHn`,
	"logo": `Header3_logo__ruMUR`,
	"nav__item": `Header3_nav__item__2X5Bu`,
	"nav__item__list": `Header3_nav__item__list__S8JQc`,
	"nav__item__link": `Header3_nav__item__link__I3i7g`,
	"menu": `Header3_menu__lP4md`,
	"menu__logo": `Header3_menu__logo__V4+Tb`,
	"menu__top": `Header3_menu__top__GMjoK`,
	"menu__icon": `Header3_menu__icon__qenZl`,
	"menu__nav": `Header3_menu__nav__hQB6P`,
	"menu__nav__item": `Header3_menu__nav__item__hHuc8`,
	"menu__nav__link": `Header3_menu__nav__link__fHd37`,
	"menu__nav__btn": `Header3_menu__nav__btn__Ex4bn`
};
export default ___CSS_LOADER_EXPORT___;
